import { cn } from "@src/shared/lib/utils";
import { getAssetUrl } from "@src/shared/utils/assets/getAssetUrl";

interface LogoProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  variant?: "mark" | "lockup";
}

export const Logo = ({
  className,
  variant = "mark",
  alt,
  ...restProps
}: LogoProps) => {
  const isLockup = variant === "lockup";

  return (
    <img
      {...restProps}
      src={getAssetUrl(
        isLockup ? "/images/slate-logo.png" : "/images/slate-logo-mark.png",
      )}
      alt={alt ?? (isLockup ? "Slate by Elation Health" : "Slate")}
      className={cn("h-8 w-auto object-contain", className)}
    />
  );
};
